export var WidgetMigrationStatus;
(function (WidgetMigrationStatus) {
    WidgetMigrationStatus[WidgetMigrationStatus["OLD"] = 1] = "OLD";
    WidgetMigrationStatus[WidgetMigrationStatus["MIGRATED"] = 2] = "MIGRATED";
    WidgetMigrationStatus[WidgetMigrationStatus["NEW"] = 3] = "NEW";
})(WidgetMigrationStatus || (WidgetMigrationStatus = {}));
export var ChatBlockContactMode;
(function (ChatBlockContactMode) {
    ChatBlockContactMode[ChatBlockContactMode["HIDE_CONTACT"] = 1] = "HIDE_CONTACT";
    ChatBlockContactMode[ChatBlockContactMode["SHOW_CONTACT"] = 2] = "SHOW_CONTACT";
})(ChatBlockContactMode || (ChatBlockContactMode = {}));
export var ContactMode;
(function (ContactMode) {
    ContactMode[ContactMode["CONTACT_FORM"] = 1] = "CONTACT_FORM";
    ContactMode[ContactMode["CONTACT_VIA_CHAT"] = 2] = "CONTACT_VIA_CHAT";
    ContactMode[ContactMode["BLOCK_CHAT"] = 3] = "BLOCK_CHAT";
})(ContactMode || (ContactMode = {}));
export var WidgetModuleType;
(function (WidgetModuleType) {
    WidgetModuleType[WidgetModuleType["KB"] = 10] = "KB";
    WidgetModuleType[WidgetModuleType["TICKET"] = 20] = "TICKET";
    WidgetModuleType[WidgetModuleType["CHAT"] = 30] = "CHAT";
})(WidgetModuleType || (WidgetModuleType = {}));
//# sourceMappingURL=widget.i.js.map